/** Area2D parser: the Node2D transform plus monitoring, monitorable, layer and mask. */
import { parseNode2D } from '../../../base/node2d/parser';
import { parseOptionalBool, parseOptionalInt } from '../../../../parser/valueParsers';
export function parseArea2D(heading, properties) {
    const node2d = parseNode2D(heading, properties);
    const result = { ...node2d };
    const monitoring = parseOptionalBool(properties.monitoring);
    if (monitoring !== undefined)
        result.monitoring = monitoring;
    const monitorable = parseOptionalBool(properties.monitorable);
    if (monitorable !== undefined)
        result.monitorable = monitorable;
    const collisionLayer = parseOptionalInt(properties.collision_layer, 'uint32');
    if (collisionLayer !== undefined)
        result.collision_layer = collisionLayer;
    const collisionMask = parseOptionalInt(properties.collision_mask, 'uint32');
    if (collisionMask !== undefined)
        result.collision_mask = collisionMask;
    return result;
}
//# sourceMappingURL=parser.js.map